(function($) {
	'use strict';

	function loadTabContent() {
		var $tabHeader = $(this);
		var tabHref = $tabHeader.attr('href');
		if (tabHref.indexOf('#') === -1) {
			return;
		}
		var $tabPane = $(tabHref);
		if ($tabPane.length !== 1) {
			console.error('Tab should reference exactly one tab', $tabHeader, $tabPane);
			return;
		}

		var src = $tabPane.data('src');
		if (!src) {
			return;
		}

		$tabPane.showLoader();
		$.get(src, { t: Date.now() })
			.done(function(result) {
				$tabPane.html(result);
				$tabPane.trigger('loaded');
			})
			.fail(function(xhr) { $tabPane.html(xhr.responseText); })
			.always(function() { $tabPane.showLoaderImmediately().hideLoader(); }); // Hide loader with animation
	}

	$(document).on('show.bs.tab', 'a[data-toggle=tab]', loadTabContent);
	$(document).on('loaded', function(event) {
		var $activeTabs = $(event.target).find('.preload > a[data-toggle=tab]');
		$activeTabs.each(loadTabContent);
	});
})(jQuery);
